import { getStorage } from '../helper/localStorage';

class AuthService {
  getCurrentUser = () => {
    return JSON.parse(getStorage('user'));
  };
}

export default new AuthService();
